var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{staticStyle:{"margin-left":"8px"},attrs:{"type":"default"},on:{"click":_vm.goBack}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }